import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import Spinners from '../../components/spinner';
import AuthService from '../../services/authService';

function Login(): JSX.Element {
  const authService = new AuthService();
  const navigate = useNavigate();

  useEffect(() => {
    if (authService.isAuthenticated()) {
      navigate('/');
    } else {
      authService.signInRedirect();
    }
  }, []);

  return <Spinners containerClassName='h-normal-screen' />;
}

export default Login;
